import "@mdi/font/scss/materialdesignicons.scss";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import axios from "axios";

Vue.config.productionTip = false;

axios
  .get("/environment.json")
  .then((resp) => {
    if (resp.status === 200) {
      window["envConfig"] = resp.data;
    }
  })
  .catch((err) => {
    console.error("Failed to retrieve environment.json", err);
  })
  .finally(() => {
    new App({
      router,
      i18n,
    }).$mount("#app");
  });
